import requirementAdd from "@/pages/requirement/requirementAdd.vue";
import requirementList from "@/pages/requirement/requirementList.vue";
import requirementSummary from "@/pages/requirement/requirementSummary.vue";
import requirementBreak from "@/pages/requirement/requirementBreak.vue";
import requirementEdit from "@/pages/requirement/requirementEdit.vue";
import requirementDetail from "@/pages/requirement/requirementDetail.vue";

import {PathName} from "@/constant/routeData";

export default [
  {
    path: '/reqRequest',
    name: PathName.ReqRequest,
    component: requirementAdd,
  },
  {
    path: '/reqList',
    name: PathName.ReqList,
    component: requirementList,
  },
  {
    path: '/reqSummary',
    name: PathName.ReqSummary,
    component: requirementSummary,
  },
  {
    path:'/subReq/:req_no?',
    name: PathName.SubReqRequest,
    component: requirementBreak
  },
  {
    path:'/reqEdit/:req_no?',
    name: PathName.ReqEdit,
    component: requirementEdit
  },
  {
    path:'/reqDetail/:req_no?',
    name: PathName.ReqDetail,
    component: requirementDetail
  }
]
